import { render, staticRenderFns } from "./EmailListTable.vue?vue&type=template&id=68c797ce&scoped=true&"
import script from "./EmailListTable.vue?vue&type=script&lang=js&"
export * from "./EmailListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c797ce",
  null
  
)

export default component.exports